<template>
  <lazy-theme4-base-not-found
    class="tw-flex tw-items-center tw-justify-center tw-text-center"
    :is-full-screen-error="true"
    :background-color="vars.backgroundColor"
  >
    <template v-if="variant === variants.v1" #title>
      <h3 class="tw-pb-8">{{ vars.titleText }}</h3>
      <nuxt-link :class="`n-${vars.buttonTypeText}`" :to="vars.buttonLinkUrl">
        {{ vars.buttonLabelText }}
      </nuxt-link>
    </template>

    <template v-else-if="variant === variants.v2" #title>
      <h1>404</h1>
      <h3 class="tw-pb-8">{{ vars.titleText }}</h3>
      <p class="tw-pb-8">{{ vars.descriptionText }}</p>
      <nuxt-link :class="`n-${vars.buttonTypeText}`" :to="vars.buttonLinkUrl">
        {{ vars.buttonLabelText }}
      </nuxt-link>
    </template>

    <template v-else-if="variant === variants.v3" #title>
      <h1 class="lg:!tw-text-[150px]" style="color: #f7f0f0 !important">404</h1>
      <h1 class="tw-pb-8">{{ vars.titleText }}</h1>
      <p class="tw-pb-8">{{ vars.descriptionText }}</p>
      <nuxt-link :class="`n-${vars.buttonTypeText}`" :to="vars.buttonLinkUrl">
        {{ vars.buttonLabelText }}
      </nuxt-link>
    </template>
  </lazy-theme4-base-not-found>
</template>

<script lang="ts">
import { ComponentMixin } from '~/mixins/component.mixin';

export default defineNuxtComponent({
  name: 'NotFoundPage',

  mixins: [ComponentMixin],

  setup() {
    const event = useRequestEvent();

    // event will be undefined in the browser
    if (event) {
      // Set the status message as well
      setResponseStatus(event, 404, 'Page Not Found');
    }
  },

  data() {
    return {
      variants: {
        v1: 'v1',
        v2: 'v2',
        v3: 'v3',
      },
    };
  },
});
</script>
